import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'highlight';
}
export function Card({
  children,
  className = '',
  variant = 'default'
}: CardProps) {
  const baseStyles = 'rounded-xl p-6 md:p-8 transition-all duration-300';
  const variants = {
    default: 'bg-slate-900/50 border border-slate-800/50 backdrop-blur-sm',
    highlight: 'bg-slate-800/80 border border-amber-500/20 shadow-xl shadow-amber-900/10'
  };
  return <div className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-200">
      {children}
    </div>;
}